import React, { useState, useEffect } from 'react';
import { getLatestBigFiveTestResult } from '../services/bigFiveTestService';

import resultText from '../assets/result-text-ko.json';
import axios from 'axios';
import { Link } from 'react-router-dom';

const BigFiveTestResultDisplay: React.FC = () => {
  const [latestResult, setLatestResult] = useState<any>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchResult = async () => {
      try {
        // const data = await getLatestBigFiveTestResult();
        const data = await axios.get('/api/big-five-test/latest-result');
        setLatestResult(data);
      } catch (error: any) {
        console.error('Error fetching latest result:', error);
        setError(error.message);
      }
      setLoading(false);
    };

    fetchResult();
  }, []);

  const getScoreLevel = (score: number) => {
    if (score <= 56) return 'low';
    if (score <= 88) return 'neutral';
    return 'high';
  };

  if (loading) return <div>Loading...</div>;
  if (error && error !== 'Request failed with status code 404') return <div>에러: {error}</div>;
  if (!latestResult) {
    return (
      <div>
        <p>아직 Big-Five 성격 검사 결과가 없습니다.</p>
        <Link to="/big-five-test">검사하러 가기</Link>
      </div>
    );
  }

  const { results } = latestResult.data;
  console.log('Destructured results:', results);

  return (
    <div className="result-card numeric-display">
      {resultText.map(domain => {
        const score = results[domain.domain];

        if (typeof score !== 'number') {
          console.warn(`결과에 ${domain.domain} 점수가 없음`, results);
          return (
            <div key={domain.domain} className="domain-result">
              <h2>{domain.title}</h2>
              <p>점수 데이터가 없습니다.</p>
            </div>
          );
        }

        const level = getScoreLevel(score);
        const matched = domain.results.find(r => r.score === level);

        return (
          <div key={domain.domain} className="domain-result">
            <h2>{domain.title}</h2>
            <p className="short-description">{domain.shortDescription}</p>
            <div className="score-display">
              <span className="factor-name">점수</span>
              <span className="factor-score">{score} 점 </span>
            </div>
            <p className="result-text">{matched?.text ?? '설명 없음'}</p>
          </div>
        );
      })}
    </div>
  );
};

export default BigFiveTestResultDisplay;
